import Button from "../../components/ui/Button";
import Modal from "../../components/ui/Modal";
import React, { useState, useEffect } from "react";
import { VendorProduct } from "../../types/vendor";
import "../EditVendorModal/EditVendorModal.css";

type ProductUpdateData = Partial<
  Pick<VendorProduct, "name" | "description" | "quantity" | "productStatus">
>;

interface EditProductModalProps {
  product: VendorProduct;
  onClose: () => void;
  onSave: (updates: ProductUpdateData) => void;
  isSaving: boolean;
}

const EditProductModal: React.FC<EditProductModalProps> = ({
  product,
  onClose,
  onSave,
  isSaving,
}) => {
  const [formData, setFormData] = useState<ProductUpdateData>({});

  useEffect(() => {
    setFormData({
      name: product.name,
      description: product.description,
      quantity: product.quantity,
      productStatus: product.productStatus,
    });
  }, [product]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value, type } = e.target;
    const finalValue = type === "number" ? parseInt(value, 10) || 0 : value;
    setFormData((prev) => ({ ...prev, [name]: finalValue }));
  };

  const handleStatusChange = (status: VendorProduct["productStatus"]) => {
    setFormData((prev) => ({ ...prev, productStatus: status }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Modal title={<>Edit Product Details</>} onClose={onClose} size="medium">
<div className="modal-content legacy-modal-content">

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Product Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name || ""}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description || ""}
              onChange={handleChange}
              rows={3}
              required
            ></textarea>
          </div>
          <div className="form-group">
            <label htmlFor="quantity">Quantity</label>
            <input
              type="number"
              id="quantity"
              name="quantity"
              value={formData.quantity || 0}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Product Status</label>
            <div className="status-toggle">
              <Button
                type="button"
                className={
                  formData.productStatus === "in_stock" ? "active" : ""
                }
                onClick={() => handleStatusChange("in_stock")}
              >
                In Stock
              </Button>
              <Button
                type="button"
                className={
                  formData.productStatus === "out_of_stock" ? "active" : ""
                }
                onClick={() => handleStatusChange("out_of_stock")}
              >
                Out of Stock
              </Button>
            </div>
          </div>
          <div className="modal-actions">
            <Button
              type="button"
              className="btn-cancel"
              onClick={onClose}
              disabled={isSaving}
            >
              Cancel
            </Button>
            <Button variant="primary" type="submit" className="btn-save" disabled={isSaving}>
              {isSaving ? "Saving..." : "Save Changes"}
            </Button>
          </div>
        </form>
      </div>
</Modal>
  );
};

export default EditProductModal;
